"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _components = require("components");

var _auth = require("redux/modules/auth");

var authActions = _interopRequireWildcard(_auth);

var _reduxForm = require("redux-form");

var _signupFormValidation = require("utils/signupFormValidation");

var _signupFormValidation2 = _interopRequireDefault(_signupFormValidation);

var _notifications = require("redux/modules/notifications");

var _reactRedux = require("react-redux");

var _SignUpPopup = require("@quixeltools/quixel-ui-library/dist/components/common/website/SignUpPopup");

var _SignUpPopup2 = _interopRequireDefault(_SignUpPopup);

var _RedirectToExternalSite = require("./../../utils/RedirectToExternalSite");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _user = require("../../redux/modules/user");

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _jsonwebtoken = require("jsonwebtoken");

var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);

var _utils = require("../../utils");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var container = (0, _glamor.css)({
  border: "none",
  marginTop: "3.75em",
  width: "100%"
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  border: "1px solid #333",
  margin: "200px auto",
  width: "" + (_css.sizes.innerMaxWidthTighter + 4)
}));

var Signup = (_dec = (0, _reduxForm.reduxForm)({
  form: "signup",
  fields: ["email", "password"],
  validate: _signupFormValidation2.default
}, function (state) {
  return {
    auth: state.auth,
    avatarfileName: state.auth.avatarfileName
  };
}, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {};
}, { markAsSeen: _notifications.markAsSeen, activateTrial: _user.activateTrial, setWorkInfo: _user.setWorkInfo }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Signup, _React$Component);

  function Signup(props) {
    (0, _classCallCheck3.default)(this, Signup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Signup.__proto__ || (0, _getPrototypeOf2.default)(Signup)).call(this, props));

    _this.onSignupSubmit = _this.onSignupSubmit.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.getSelectedWorkInfo = _this.getSelectedWorkInfo.bind(_this);

    _this.state = {
      transitioned: false,
      error: null,
      termsChecked: false,
      workInfo: "",
      other: ""
    };
    return _this;
  }

  (0, _createClass3.default)(Signup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          location = _props.location,
          auth = _props.auth;

      if (auth.loggedIn && location.query.return_to && (location.query.return_to.indexOf("quixel.zendesk.com") > -1 || location.query.return_to.indexOf("help.quixel.com") > -1 || location.query.return_to.indexOf("zendesk.com") > -1)) {
        this.props.loginWithSSOZendesk({});
      }
      var _interval_ = setInterval(IgnoreElement, 1000);

      function IgnoreElement() {
        if (typeof CE2 !== "undefined") {
          var elP = document.getElementsByTagName("input").password;
          var elE = document.getElementsByTagName("input").email;
          var list = CE2.ignoredElements;

          if (elP) CE2.ignore(elP);
          if (elE) CE2.ignore(elE);

          if (CE2.ignoredElements.length > 0) clearInterval(_interval_);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var location = this.props.location;


      if (nextProps.auth.zendeskTokenSSO && nextProps.auth.zendeskTokenSSO !== this.props.auth.zendeskTokenSSO) {
        var tokenObject = _jsonwebtoken2.default.decode(nextProps.auth.zendeskTokenSSO);
        if (_underscore2.default.isEmpty(tokenObject.name)) {
          this.context.dialogs.custom(_react2.default.createElement(_components.ZendeskScreenNamePopupContainer, null));
        } else {
          if (location.query.return_to) {
            var return_to = location.query.return_to;
            var hostName = "https://" + (0, _utils.extractHostname)(return_to);
            if (!/\d/.test(hostName)) {
              hostName = "https://quixel.zendesk.com";
            }
            var zendeskJwtLink = hostName + "/access/jwt?jwt=" + nextProps.auth.zendeskTokenSSO + "&return_to=" + encodeURIComponent(return_to);
            (0, _RedirectToExternalSite.checkRedirectRequired)(zendeskJwtLink);
          }
        }
      }
      if (nextProps.auth.avatarSrc && this.props.auth.avatarSrc !== nextProps.auth.avatarSrc) {
        this.props.uploadAvatarZendesk(nextProps.auth.avatarSrc);
      }
      if (this.props.auth.screenName !== nextProps.auth.screenName && nextProps.auth.screenName && this.props.auth.zendeskTokenSSO) {
        var data = {
          token: this.props.auth.zendeskTokenSSO,
          screenName: nextProps.auth.screenName
        };
        if (this.props.auth.avatarfileName) data.avatarUrl = this.props.auth.avatarfileName;
        this.props.updateScreenNameSSOZendesk(data);
      }
    }
  }, {
    key: "onSignupSubmit",
    value: function onSignupSubmit(values) {
      var _this2 = this;

      var _props2 = this.props,
          closePopup = _props2.closePopup,
          navigateTo = _props2.navigateTo;
      var email = values.email,
          password = values.password;


      this.setState({
        error: null
      });

      return this.props.registerAndLogin({ email: email, password: password }).then(function () {
        var _props3 = _this2.props,
            markAsSeen = _props3.markAsSeen,
            activateTrial = _props3.activateTrial,
            location = _props3.location,
            setWorkInfo = _props3.setWorkInfo;
        var _context = _this2.context,
            router = _context.router,
            dialogs = _context.dialogs;

        var data = {
          workInfo: _this2.state.workInfo,
          industry: [_this2.state.other]
        };
        markAsSeen();
        setWorkInfo(data).then(function (res) {}).catch(function (error) {
          _this2.setState({
            error: error.message
          });
        });
        var returnTo = location.query.returnTo && location.query.returnTo.indexOf("login") === -1 ? location.query.returnTo : "/";

        if (location.query.return_to && (location.query.return_to.indexOf("quixel.zendesk.com") > -1 || location.query.return_to.indexOf("help.quixel.com") > -1 || location.query.return_to.indexOf("zendesk.com") > -1)) {
          _this2.props.loginWithSSOZendesk({
            email: email,
            password: password,
            realm: "megascans"
          });
          //window.location=location.query.return_to;
        } else {
          if (returnTo === "/megascans/library/free") {
            activateTrial().then(function () {
              if (closePopup) {
                dialogs.custom(_react2.default.createElement(_components.TrialPopup, null));
                closePopup();
              } else router.push(returnTo);
            });
          } else if (!returnTo.toLowerCase().startsWith("/subscribe")) {
            if (closePopup) {
              dialogs.custom(_react2.default.createElement(_components.TrialPopup, null));
              closePopup();
              router.push("/megascans/library/free");
            } else router.push(returnTo);
          } else {
            if (closePopup) closePopup();
            router.push(returnTo);
          }
        }
      }).catch(function (error) {
        _this2.setState({
          error: error.message
        });
      });
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      e.preventDefault();
      this.setState({
        termsChecked: !this.state.termsChecked
      });
    }
  }, {
    key: "getSelectedWorkInfo",
    value: function getSelectedWorkInfo(workInfo, other) {
      this.setState({
        workInfo: workInfo,
        other: other
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props4 = this.props,
          _props4$fields = _props4.fields,
          emailInputProps = _props4$fields.email,
          passwordInputProps = _props4$fields.password,
          submitting = _props4.submitting,
          handleSubmit = _props4.handleSubmit,
          childReference = _props4.childReference,
          location = _props4.location;
      var error = this.state.error;

      var helpReturnTo = location.query.return_to && (location.query.return_to.indexOf("quixel.zendesk.com") > -1 || location.query.return_to.indexOf("help.quixel.com") > -1 || location.query.return_to.indexOf("zendesk.com") > -1);
      return _react2.default.createElement(
        _components.AppSideEffects,
        { documentTitle: "Signup" },
        _react2.default.createElement(_SignUpPopup2.default, {
          icon: "/quixel_2080_logo.png",
          error: error,
          emailInputProps: emailInputProps,
          passwordInputProps: passwordInputProps,
          signInTo: {
            pathname: "/login",
            query: this.props.location.query,
            state: { modal: !helpReturnTo }
          },
          submitting: submitting,
          onSubmit: handleSubmit(this.onSignupSubmit),
          onChildRef: childReference,
          termsChecked: this.state.termsChecked,
          onChange: this.onChange,
          getSelectedWorkInfo: this.getSelectedWorkInfo
        })
      );
    }
  }]);
  return Signup;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);

var SignupPopup = function (_React$Component2) {
  (0, _inherits3.default)(SignupPopup, _React$Component2);

  function SignupPopup(props) {
    (0, _classCallCheck3.default)(this, SignupPopup);
    return (0, _possibleConstructorReturn3.default)(this, (SignupPopup.__proto__ || (0, _getPrototypeOf2.default)(SignupPopup)).call(this, props));
  }

  (0, _createClass3.default)(SignupPopup, [{
    key: "render",
    value: function render() {
      var isPopup = this.props.isPopup;


      if (isPopup) {
        return _react2.default.createElement(Signup, this.props);
      }

      return _react2.default.createElement(
        "div",
        { className: container },
        _react2.default.createElement(Signup, this.props)
      );
    }
  }]);
  return SignupPopup;
}(_react2.default.Component);

exports.default = SignupPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Signup/Signup.jsx
// module id = 2905
// module chunks = 0